// Compliance Manager for financial and data compliance
import { FinancialConfig } from './FinancialConfig';

export class ComplianceManager {
  static initialize() {
    this.complianceRules = {
      contributionCaps: {
        concessional: FinancialConfig.CONTRIBUTION_CAPS.CONCESSIONAL,
        nonConcessional: FinancialConfig.CONTRIBUTION_CAPS.NON_CONCESSIONAL,
        carryForwardYears: 5
      },
      transferBalanceCap: FinancialConfig.TRANSFER_BALANCE_CAP,
      agePensionAssets: {
        single: { 
          full: FinancialConfig.AGE_PENSION.ASSET_TEST.SINGLE_HOMEOWNER.FREE_THRESHOLD, 
          part: FinancialConfig.AGE_PENSION.ASSET_TEST.SINGLE_HOMEOWNER.CUT_OFF 
        },
        couple: { 
          full: FinancialConfig.AGE_PENSION.ASSET_TEST.COUPLE_HOMEOWNER.FREE_THRESHOLD, 
          part: FinancialConfig.AGE_PENSION.ASSET_TEST.COUPLE_HOMEOWNER.CUT_OFF 
        }
      },
      superannuationGuarantee: FinancialConfig.SUPERANNUATION_GUARANTEE.RATE,
      workTestAge: 67,
      preservationAge: 60
    };
    
    this.auditLog = [];
    this.complianceViolations = [];
    
    console.log('ComplianceManager initialized');
  }

  // Validate contribution compliance
  static validateContributions(concessional, nonConcessional, totalSuperBalance) {
    const violations = [];
    
    if (concessional > this.complianceRules.contributionCaps.concessional) {
      violations.push({
        type: 'concessional_excess',
        message: `Concessional contributions exceed cap`,
        severity: 'error'
      });
    }
    
    if (nonConcessional > this.complianceRules.contributionCaps.nonConcessional) {
      violations.push({
        type: 'non_concessional_excess',
        message: `Non-concessional contributions exceed cap`,
        severity: 'error'
      });
    }
    
    return {
      valid: violations.length === 0,
      violations
    };
  }

  // Audit calculation for compliance
  static auditCalculation(calculationType, inputs, results) {
    const auditEntry = {
      timestamp: new Date().toISOString(),
      type: calculationType,
      inputs: inputs,
      results: results
    };
    
    this.auditLog.push(auditEntry);
    return auditEntry;
  }

  // Get compliance report
  static getComplianceReport() {
    return {
      totalCalculations: this.auditLog.length,
      violations: this.complianceViolations.length,
      recentViolations: this.complianceViolations.slice(-10)
    };
  }
}